module.exports = __webpack_public_path__ + "static/media/Daniela-Shvartsman-Resume-2018.ca69dd5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/Daniela-Shvartsman-Resume-2018.jpg
// module id = 108
// module chunks = 0